import * as React from 'react';
import { currentSecondaryDimensionContext } from './context';
export var CurrentSecondaryDimensionContextProvider = function (props) {
    var currentSecondaryDimension = props.currentSecondaryDimension, children = props.children;
    return (React.createElement(currentSecondaryDimensionContext.Provider, { value: currentSecondaryDimension }, children));
};
